import React from "react";
import { Box, ThemeProvider, createTheme } from "@mui/material";
import noImage from "../../shared/assets/images/noImage.png";

export interface ImageBoxProps {
  size?: "small" | "medium";
  src?: string;
  circle?: boolean;
  customSize?: number;
}

const ImageBox = ({ size = "medium", src, circle, customSize }: ImageBoxProps) => {
  const sideImage = size === "small" ? 48 : 120;
  const circleImage = size === "small" ? 60 : 120;

  const theme = createTheme({});

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: customSize ? customSize : circle ? circleImage : sideImage,
          width: customSize ? customSize : circle ? circleImage : sideImage
        }}
      >
        <img
          className="aspect-square object-cover w-full"
          style={{
            border: circle ? "none" : "1px solid #C7C9CD",
            borderRadius: circle ? "50%" : size === "small" ? "4px" : "8px"
          }}
          src={src || noImage}
          alt=""
        />
      </Box>
    </ThemeProvider>
  );
};

export default ImageBox;
